__turbopack_context__.v({
  "card": "PaymentCardDetails-module-scss-module__ZQu_XW__card",
  "code": "PaymentCardDetails-module-scss-module__ZQu_XW__code",
  "month": "PaymentCardDetails-module-scss-module__ZQu_XW__month",
  "validation": "PaymentCardDetails-module-scss-module__ZQu_XW__validation",
  "year": "PaymentCardDetails-module-scss-module__ZQu_XW__year",
});
